//Local
//export const API =
//  "http://127.0.0.1:8000/api";
//Local Para compartir con el equipo casa
//  "http://192.168.1.90:8000/api";
//Local Para compartir con el equipo trabajo
//  "http://172.16.8.156:8000/api";
//Producción
export const API =
  "https://skyclearback.skyangel.com.mx/api";

//export const BACKEND_URL =
//  "http://127.0.0.1:8000";
//Local Para compartir con el equipo casa
//  "http://192.168.1.90:8000";
//Local Para compartir con el equipo trabajo
//  "http://172.16.8.156:8000";
//Producción
export const BACKEND_URL =
  "https://skyclearback.skyangel.com.mx";